import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  markAsPrintedLabel: {
    description: 'Label Batch Status Modal > Not yet printed. Click to mark as printed.',
    defaultMessage: 'Not yet printed. Click to mark as printed.',
    id: 'kZKXBZ',
  },
  batchPrintDateLabel: {
    description: 'Label Batch Status Modal > Printed on (date)',
    defaultMessage: 'Printed on {batchPrintDate}',
    id: 'Xo7umX',
  },
  inlineErrorForPrintDate: {
    description: 'Label Batch Status Modal > Printed Date Error Message',
    defaultMessage: 'There are no active Shipments for this Batch.',
    id: 'dsIVpI',
  },
});
